import React from "react";
import { CGE } from "../../../../common/components/CGE";
import classNames from 'classnames';
import { urlParams, getPathName, trimLeadingZeros } from "../../../../common/utils/utilsFunc"

const BusquedaTable = ({ dataTable, flagRoute, hideSearch, changeInputNumClient, inputForms,setNumIdEstasSinLuz,setNumIdPagoEnLinea }) => {
    const [flagEstasSinLuz, setFlagEstasSinLuz] = React.useState(false);
    const [flagPagoEnLinea, setFlagPagoEnLinea] = React.useState(false);
    
    function elementInsideAnother() {
        if (getPathName() === "para-estar-informados-completa-tus-datos" ) {
            return true
        } else {
            return false;
        }
    }

    React.useEffect(() => {
        if(window.location.search.includes("estas-sin-luz")) {
            setFlagEstasSinLuz(true);
        }
    },[dataTable,urlParams.get('estas-sin-luz')]);

    React.useEffect(() => {
        if(window.location.search.includes("pago-en-linea")) {
            setFlagPagoEnLinea(true);
        }
    },[dataTable,urlParams.get('pago-en-linea')]);
    
    return (
        <table className={classNames(
            "cge-busqueda__table table",
            {
                'mobile-table-update-contact-page': getPathName() === "para-estar-informados-completa-tus-datos",
            }
        )} >
            <tr>
                {(elementInsideAnother() || flagEstasSinLuz || flagPagoEnLinea) && <th>Seleccionar</th>}
                <th>Nº Cliente</th>
                <th>Dirección</th>
                {/* {(getPathName() !== "para-estar-informados-completa-tus-datos") && <th>Link</th>} */}
            </tr>
            {flagRoute === 0 ?
                dataTable && dataTable.map((item) => (
                    <tr>
                        {elementInsideAnother() && <td className="cge-busqueda__icon">
                            <a
                                value={item.cuentaContrato}
                                onClick={() => {
                                    hideSearch(false)
                                    changeInputNumClient({ ...inputForms, numCli: trimLeadingZeros(item.cuentaContrato) })
                                    flagEstasSinLuz?setNumIdEstasSinLuz(item.cuentaContrato):setNumIdPagoEnLinea(item.cuentaContrato);
                                }}
                            >
                                <CGE.Icon name="check" />
                            </a>
                        </td>}
                        {(flagEstasSinLuz || flagPagoEnLinea) && <td className="cge-busqueda__icon">
                            <a
                                value={item.cuentaContrato}
                                onClick={() => {
                                    flagEstasSinLuz?setNumIdEstasSinLuz(item.cuentaContrato):setNumIdPagoEnLinea(item.cuentaContrato);
                                }}
                            >
                                <CGE.Icon name="check" title="Seleccionar nº cliente" />
                            </a>
                        </td>}
                        <td>{item.cuentaContrato}</td>
                        <td>{item.direccion}</td>
                        {/* <td>
                            <a href={`/web/guest/pago-en-linea?cuentaContrato=${item.cuentaContrato}`}>Pagar</a>
                            <br />
                            <a href={`/web/guest/estas-sin-luz?nrcli=${item.cuentaContrato}`}>¿Estás sin luz?</a>
                        </td> */}
                    </tr>
                ))
                :
                dataTable && dataTable.map((item) => (
                    <tr>
                        {elementInsideAnother() && <td className="cge-busqueda__icon">
                            <a
                                value={item.cuentaContrato}
                                onClick={() => {
                                    hideSearch(false)
                                    changeInputNumClient({ ...inputForms, numCli: trimLeadingZeros(item.cuentaContrato) })
                                    setNumIdEstasSinLuz(item.cuentaContrato)
                                }}
                            >
                                <CGE.Icon name="check" />
                            </a>
                        </td>}
                        {flagEstasSinLuz && <td className="cge-busqueda__icon">
                            <a
                                value={item.cuentaContrato}
                                onClick={() => {
                                    setNumIdEstasSinLuz(item.cuentaContrato)
                                }}
                            >
                                <CGE.Icon name="check" />
                            </a>
                        </td>}
                        <td>{item.cuentaContrato}</td>
                        <td>{item.direccion}</td>
                    </tr>
                ))
            }
        </table >
    )
};

export default BusquedaTable;